/**
 * @copyright Copyright 2024 Epic Systems Corporation
 * @file ConnectorManagement Shared Connectors App Tag List
 * @module Epic.AppOrchard.ConnectorManagement.Shared.ConnectorsAppTagList
 */

import { HStack } from "@chakra-ui/react";
import { IConnectorApp, IConnectorAppListItem } from "ao/types/connectorManagement";
import { FC, memo } from "react";
import { ReviewStatus } from "../../data/constants";
import { ConnectorsAppTag } from "./ConnectorsAppTag";

interface IConnectorAppTagListProps {
	connectorApp: IConnectorApp | IConnectorAppListItem;
}

export const ConnectorsAppTagList: FC<IConnectorAppTagListProps> = memo((props) => {
	const { connectorApp } = props;
	return (
		<HStack paddingTop="5px">
			{connectorApp.isDeleted && (
				<ConnectorsAppTag
					label="Soft-Deleted"
					title="This app has been soft-deleted."
					colorScheme="red"
				/>
			)}
			{connectorApp.reviewStatus?.id === ReviewStatus.Merged && (
				<ConnectorsAppTag
					label="Merged"
					title="This app has been merged into a different app."
					colorScheme="cyan"
				/>
			)}
			{connectorApp.isEpicOnFHIR && (
				<ConnectorsAppTag
					label="Epic On FHIR"
					title="This app was created in Epic on FHIR. Details may not be reliable."
					colorScheme="orange"
				/>
			)}
			{connectorApp.isPrivateApp && (
				<ConnectorsAppTag
					label="Homegrown"
					title="This app is private to this organization."
					colorScheme="green"
				/>
			)}
		</HStack>
	);
});
